import create from 'zustand';

export const useConstructionManagerStore = create((set) => ({
    selectedManager: null,
    setSelectedManager: (manager) => set({selectedManager: manager}),
}));
